import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import './mobile.css';
import App from './App';
import Landing from './Landing';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
      <Routes>
        {/* Marketing splash is the public front door. */}
        <Route path="/" element={<Landing />} />
        {/* Full web dashboard kept (unlinked) for existing web users. */}
        <Route path="/app" element={<App />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
      </Routes>
    </BrowserRouter>
);
